import React from 'react';
import { Box, Container } from '@mui/material';
import Breadcrumbs from './Breadcrumbs';

const PageLayout = ({ children, showBreadcrumbs = true }) => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
      <Container sx={{ py: 12 }}>
        {showBreadcrumbs && <Breadcrumbs />}
        {children}
      </Container>
    </Box>
  );
};

export default PageLayout;
